export const SAVE = 'step9.SAVE';
export const VALUE_CHANGED = 'step9.VALUE_CHANGED';
export const LOAD = 'step9.VALUE_LOAD';
export const NEXT = 'step9.NEXT';
export const RESET = 'step9.RESET';



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step9/constants.js